import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand } from '@commander-js/extra-typings';

export const devCommand = (services: CommandServices, cliVersion: string) => {
  return createCommand('dev')
    .option(
      '--port <port>',
      'Specify which port to run on. Defaults to 4321.',
      (value) => {
        return parseInt(value, 10);
      }
    )
    .option(
      '--allowed-hosts <allowedHosts>',
      'Specify a comma-separated list of allowed hosts or allow any hostname.'
    )
    .option(
      '--base-url <baseUrl>',
      'Base URL to use instead of a localhost when running dev command'
    )
    .action(async (options, command) => {
      const { DevCommand } = await import('../components/DevCommand/index.js');
      const { renderCommand } = await import('./render-command.js');

      await renderCommand(
        command,
        services,
        cliVersion,
        <DevCommand
          port={options.port}
          allowedHosts={options.allowedHosts}
          serverExposedUrl={options.baseUrl}
        />
      );
    });
};
